import SupplierForm from '../components/SupplierForm';
import { cancelSupplierCreate, createSupplierRequest } from '../../../api/suppliers/suppliersSlice';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Stack } from '@mui/material';

const initialData = {
  name: '',
  company_name: '',
  company_name_in_local: '',
  email: '',
  address1: '',
  address2: '',
  address3: '',
  city: '',
  country_code: '',
  state: '',
  postal_code: '',
  phone: '',
  registration_type: '',
  registration_number: '',
  tin: '',
  sst_registration_number: '-',
  tourism_tax_registration_number: '-',
  msic_code: '',
};

export default function CreateSuppliersPage() {
  useDocumentTitle('New Supplier Form');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isSupplierCreated, error } = useSelector((state) => state.suppliers);

  useEffect(() => {
    if (isSupplierCreated) {
      navigate('/suppliers');
    }
  }, [isSupplierCreated, navigate]);

  const handleSubmit = (data) => {
    const payload = {
      ...data,
      company_name: data.company_name ? data.company_name : data.name,
      country_code: data.country_code.key,
      email: data?.email ? data.email : null,
      state: data.state.key || data.state,
      registration_type: data.registration_type.key,
      msic_code: data.msic_code.key,
    };

    delete payload.participant_id;
    dispatch(createSupplierRequest(payload));
  };

  function handleCancel() {
    dispatch(cancelSupplierCreate());
    return navigate('/suppliers');
  }

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <SupplierForm
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={initialData}
        apiErrors={error}
      ></SupplierForm>
    </Stack>
  );
}
